import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import TableFunction from "../../../../../components/table/TableFunction";
import {VIEW_TYPE} from "../../../../../enums/ViewType";
import {CRITERIA_MODEL, SEARCH_MODEL} from "../../../../../components/table/Model/TableModel";
import {
    SearchByFilters,
    SearchByFiltersCustom,
    SimpleSearch,
    SimpleSearchWithId
} from "../../../../../reduxToolkit/Search/SearchApi";
import {TABLES} from "../../../../../Apis/Tables";


/**
 *
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 *
 */
const SupplierCardsApp = (
    {
        view,
        searchElement,
        supplierId,
        modified,
        setModified,
        finalArray,
        setCriteria,
        setIsAllChecked,
        selectedList,
        setSelectedList,
        setBodyForExport,
    }
) => {
    const dispatch = useDispatch();
    const { t } = useTranslation(); // Destructure translation function for multi-language support
    const navigate = useNavigate(); // Set up navigation functionality
    const [results, setResults] = useState({ content: [], totalElements: 0 });
    const [option, setOption] = useState(`${TABLES.SUPPLIERS}`); // State to store the selected table option (contracts)
    const elementRefTable = useRef(null); // Reference to the element for positioning (used for layout effects)
    // Access state values from Redux store
    const DEV = useSelector((state) => state?.CommonsSlice?.development); // Access development state for conditional rendering
    const { permission } = useSelector((state) => state.authenticatioauthennSlice); // Access user permission data

    // useLayoutEffect hook to adjust positioning of elements when the view changes
    useEffect(() => {
        if (elementRefTable?.current) {
            const rect = elementRefTable.current.getBoundingClientRect(); // Get the element's position on the screen
            const distanceTop = rect.top + 0; // Calculate the top position of the element
            elementRefTable.current.style.setProperty('--top-value', `${distanceTop}px`); // Update the custom CSS property for positioning
        }
    }, [results]); // Dependency array ensures the effect runs when the 'view' prop changes

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = (page) => {
        const body = supplierId === null ?
            SEARCH_MODEL.setObject({page, size: rowsPerPage, model:option,key: searchElement, view }) :
            SEARCH_MODEL.setObject({page, size: rowsPerPage, model:option,key: searchElement,userId: supplierId, view })

        setBodyForExport(body);
        const dispatchFunction = supplierId === null ? SimpleSearch : SimpleSearchWithId;
        dispatch(dispatchFunction({ body })).then(({payload: {data: { data, success }}}) => {
            if (success === true) {
                setResults(data);
            }
        });
    }

    /**
     * Executes a paginated search request using advanced criteria.
     *
     * Builds the criteria list based on the advanced search (finalArray),
     * appends user criteria, and dispatches the search action through Redux.
     * Updates the results and resets the selected list once the data is returned.
     */
    const getDataAdvancedSearch = (page) => {
        const criteriaList = finalArray.map((item) => {
            return CRITERIA_MODEL.set(item);
        });
        if (supplierId === null) {
            const body = SEARCH_MODEL.setObject({page, size:rowsPerPage, model:option, criteria: criteriaList, view })
            setCriteria(body);
            dispatch(SearchByFilters({ option, body })).then(
                ({
                     payload: {
                         data: { data, success },
                     },
                 }) => {
                    if (success === true) {
                        setResults(data);
                    }
                },
            );
        } else {
            const body = SEARCH_MODEL.setObject({page, size:rowsPerPage, model:option, criteria: criteriaList,  userToFindId: supplierId, view })
            setCriteria(body);
            dispatch(SearchByFiltersCustom({ option, body })).then(
                ({
                     payload: {
                         data: { data, success },
                     },
                 }) => {
                    if (success) {
                        setResults(data);
                    }
                },
            );
        }
    }

    // Use the TableFunction component to handle table logic (checkbox selection, pagination, etc.)
    const { handleCheckboxChange, handleDeleteAll,
        pagination, page, rowsPerPage, } = TableFunction({
        selectedList,
        setSelectedList, // Callback to update the selected rows
        data: results, // Table data
        labelRowsPerPage: 'suppliers_per_page', // Label for rows per page
        hasContainer: true, // Enable container for the table
        fixedPagination: false, // Disable fixed pagination
        setIsAllChecked,
        view: VIEW_TYPE.GRID.name,

        searchElement,//New
        getData,//New
        modified,//New
        setModified,//New
        getDataAdvancedSearch,//New - apply only with advance
        finalArray//New - apply only with advanced search
    });

    // Return the necessary variables and functions from the component
    return {
        DEV,
        permission,
        t, // Translation function
        navigate, // Navigation function
        elementRefTable, // Reference to the tab element
        results, // Document list results
        pagination, // Pagination component state
        handleCheckboxChange, // Checkbox change handler
        handleDeleteAll,
        setResults, // Function to update results
        option, // Selected table option (contracts)
        page, // Current page number
        rowsPerPage, // Number of rows per page
    };
}

export default SupplierCardsApp
